import { ReactNode, useContext } from 'react'
import { Helmet } from 'react-helmet-async'

import { faTachometer } from '@fortawesome/pro-light-svg-icons'

import { Box, Button } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'
import PageHeader from '@components/PageHeader'

interface PageLayoutProps {
  activeTabBarItemKey: 'overview',
  children: ReactNode,
}

const PageLayout = (props: PageLayoutProps) => {
  const { activeTabBarItemKey, children } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      showNewCampaignModal,
    },
  } = pageContext

  return (
    <>
      <Helmet>
        <title>Dashboard | Realhub</title>
      </Helmet>

      <PageHeader
        activeTabBarItemKey={activeTabBarItemKey}
        actionContent={(
          <Button
            buttonStyle="primaryCreate"
            onClick={() => showNewCampaignModal({ shouldLaunchModal: true })}
            size="medium"
          >
            Create
          </Button>
        )}
        tabBarItems={[
          // @ts-expect-error TS2741
          {
            icon: faTachometer,
            key: 'overview',
            title: 'Overview',
          },
        ]}
        title="Dashboard"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        {children}
      </Box>
    </>
  )
}

export default PageLayout
